export const sectionSx = {
  boxShadow: 'none',
  borderRadius: 0,
  bgcolor: '#fff',
  '&:before': { display: 'none' },
  '&.Mui-expanded': {
    margin: 0
  },
  p:0,
};

export const summarySx = {
  minHeight: 40,
  height: 40,
  p: 1.5,
  py:2,
  bgcolor: '#fff',
  borderBottom: '1px solid #E5E7EB',

  '&.Mui-expanded': {
    minHeight: 40,
    height: 40,
    bgcolor: '#F4F7FA'
  },

  '& .MuiAccordionSummary-content': {
    my: 0,
    alignItems: 'center',
    margin: 0
  },

  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: 0
  },

  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#424242'
  }
};

export const sectionTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242'
};

export const addIconSx = {
  p: 0.4,
  mr: 1,
  color: '#424242',

  '& svg': {
    fontSize: 18
  }
};

export const headCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: '12px',
  fontWeight: 500,
  color: '#424242',
  backgroundColor: '#FAFAFA',
  borderBottom: '1px solid #E0E0E0',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap'
};
export const tableBodyRowSx = {
  height: 40,

  '&:hover': {
    bgcolor: '#FCF8F2',

    '& .MuiTableCell-root': {
      bgcolor: 'inherit'
    }
  }
};
export const bodyCellSx = {
  height: 40,
  padding: '0 18px',
  fontSize: '13px',
  color: '#424242',
  borderBottom: '1px solid #EEEEEE',

};

export const disabledTextSx = {
  color: '#9EA4AA',
  bgcolor:'#FAFAFA',
};

export const inputSx = {
  '& .MuiOutlinedInput-root': {
    height: 38,
    fontSize: 13,
    borderRadius: '4px',
    bgcolor: '#fff',
    color:'#424242',

    '& fieldset': {
      borderColor: '#E1E5EA'
    },

    '&:hover fieldset': {
      borderColor: '#D5DAE0'
    },

    '&.Mui-focused fieldset': {
      borderColor: '#90CAF9',
      borderWidth: 1
    }
  },

  '& .MuiInputBase-input': {
    px: 1,
    py: 0,
    fontSize: 13,

    '&::placeholder': {
      color: '#757575',
      opacity: 1
    }
  }
};

export const actionIconSx = {
  p: 0.85,
  color: '#757575',

  '& svg': {
    fontSize: 18
  }
};

export const checkIconSx = {
  ...actionIconSx,
  color: '#2E7D32'
};

export const closeIconSx = {
  ...actionIconSx,
  color: '#F44336'
};